function Lienhe() {
    return (
        <p>Lien He</p>
    )
}

export default Lienhe;